export class ContentSwitcher {
	elements = {
    root: null,
    items: [],
  };

  state = {
    selectedId: null,
  }

  constructor(element) {
    if (!element) {
      return;
    }

    this.elements = {
      root: element,
      items: element.querySelectorAll('[data-id]'),
    };

    this.show(this.elements.items[0].dataset.id);
  }

	show(itemId) {
		for (const item of this.elements.items) {
      item.style.display = 'none';
    }
    this.state.selectedId = Number(itemId);
		console.log({itemId});
		this.elements.root.querySelector(`[data-id="${itemId}"]`).style.display = 'block';
	}

  get itemCount() {
    return this.elements.items.length;
  }

  get selectedItem() {
    return this.elements.root.querySelector(`[data-id="${this.state.selectedId}"]`);
  }
}
